import { MicroserviceEnum, query } from '@/helpers/westeros';
import {
  getOrCreateDexUser,
  GetOrCreateDexUserMutationResult,
} from '@/store/graphql/mutations/westerosArcaneumMutations';
import RootState from '@/store/root_state';
import { ActionTree } from 'vuex';
import { DexUserState } from './state';

const actions: ActionTree<DexUserState, RootState> = {
  async GET_OR_CREATE_DEX_USER({ commit }, payload: { tokenD: string }): Promise<void> {
    const { data } = await query<GetOrCreateDexUserMutationResult>(
      MicroserviceEnum.ARCANEUM,
      getOrCreateDexUser,
      payload,
    );

    commit('SET_DEX_USER', data.user);
  },
};

export default actions;
